<template>
  <v-container class="my-4">
    <v-row justify="center" class="text-center">
      <v-col cols="12">
        <span class="text-body-1">{{ $t('L_to_change_your_beneficiaries_first') }}</span>
        <a
          href="javascript:void(0)"
          id="us_doc_multi-purpose"
          @click="openDocument(formLinks['multiPurposeForm'], $t('L_multi_purpose_form'))"
          class="subheading font-weight-medium"
        >
          {{ $t('L_to_change_your_beneficiaries_multi_purpose_change_form') }}
        </a>

        <span>{{ $t('L_to_change_your_beneficiaries_last') }}</span>
      </v-col>
      <EmbeddedViewer
        :title="document.title"
        :loading="document.loading"
        content-type="application/pdf"
        :content-url="document.content"
        @close="document.content = undefined"
      />
    </v-row>
    <v-row justify="center" class="text-center">
      <v-col cols="12" md="12" lg="12">
        <p class="text-body-1">
          {{ $t('L_policy_beneficiaries_company_US') }}
        </p>
        <p class="text-body-1">
          {{ $t('L_policy_submit_written_request_address') }}
        </p>
        <p class="text-body-1">
          {{ $t('L_policy_submit_written_request_include_note') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import EmbeddedViewer from '@/components/EmbeddedViewer.vue';
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { FEATURE_FLAGS } from '@/shared/models/constants.models';

const componentOptions: ComponentOptions = {
  name: 'USBeneficiaryCard',
  components: {
    EmbeddedViewer,
  },
  data: () => ({
    document: {
      title: '',
      content: '' as string | undefined,
      loading: false,
    },
  }),
  computed: {
    ...mapState(useGlobalStore, ['containsFeature', 'features']),
    ...mapState(usePolicyStore, {
      beneficiaries: 'beneficiaries',
      isPending: 'isPending',
    }),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    displayBeneficiaries() {
      return (
        this.containsFeature(FEATURE_FLAGS.BENEFICIARIES) &&
        this.beneficiaries &&
        this.beneficiaries?.length > 0
      );
    },
    formLinks() {
      if (this.locale === 'en_US') {
        return { ...window.appConfig.policyDocumentForms.en_US };
      }
      return { ...window.appConfig.policyDocumentForms.es_US };
    },
  },
  methods: {
    openDocument(content: string, title: string) {
      this.document.title = title;
      this.document.content = `${window.appConfig.content_stack}${content}`;
    },
  },
};

export default defineComponent(componentOptions);
</script>
